
import { useState, useEffect } from "react";

export type ViewMode = "grid" | "list" | "network" | "frame" | "freeform";

export const usePersistentViewMode = (initialMode: ViewMode = "grid") => {
  // Initialize with stored value or default, with migration from "board" to "freeform"
  const [viewMode, setViewModeState] = useState<ViewMode>(() => {
    try {
      const storedMode = localStorage.getItem('viewMode');
      // Migrate old "board" mode to "freeform"
      if (storedMode === "board") {
        localStorage.setItem('viewMode', 'freeform');
        return "freeform";
      }
      return (storedMode as ViewMode) || initialMode;
    } catch (error) {
      console.error("Error reading view mode from localStorage:", error);
      return initialMode;
    }
  });

  // When viewMode changes, update localStorage
  useEffect(() => {
    try {
      localStorage.setItem('viewMode', viewMode);
      console.log(`[VIEW MODE] Saved view mode to localStorage: ${viewMode}`);
    } catch (error) {
      console.error("Error saving view mode to localStorage:", error);
    }
  }, [viewMode]);

  // Wrapper for setViewMode to ensure type safety
  const setViewMode = (mode: ViewMode) => {
    console.log(`[VIEW MODE] Changing view mode to: ${mode}`);
    setViewModeState(mode);
  };

  return { viewMode, setViewMode };
};
